import React, { useState } from 'react'
import PropTypes from 'prop-types'
import IrisAnimated from './example2d/IrisAnimated'
import Iris3D from './example3d/Iris3DAnimated'
import IrisTsne from './exampletSNE/irisTsne'


const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
    >
      {value === index && (
        <div className="p-3">
          {children}
        </div>
      )}
    </div>
  )
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

const DataViz = ({ navBarHeight }) => {
  const [value, setValue] = useState(0)
  const tabs = [
    'Iris 2D Interactive',
    'Iris 3D plot',
    'IRIS t-SNE visualization',
  ]

  const handleChange = (newValue) => {
    setValue(newValue)
  }

  return (
    <div className="w-full min-h-screen" style={{ paddingTop: navBarHeight }}>
      <div className="page-frame py-8">
        <nav className="mb-6 flex justify-center">
          <div className="tab-shell glass-panel glass-panel-strong">
            {tabs.map((tab, index) => (
              <button
                key={tab}
                role="tab"
                className={`tab-pill ${value === index ? 'tab-pill-active' : ''}`}
                onClick={() => handleChange(index)}
              >
                {tab}
              </button>
            ))}
          </div>
        </nav>
        <div className="rounded-[32px] glass-panel glass-panel-strong p-2 md:p-4">
        <TabPanel value={value} index={0}>
          <IrisAnimated />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Iris3D />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <IrisTsne />
        </TabPanel>
        </div>
      </div>
    </div>
  )
}

export default DataViz
